import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const IMAGES = ['https://cdn.magicpatterns.com/uploads/gso6xFqHcYDjdWGHjutXaZ/personas_5.jpg', 'https://cdn.magicpatterns.com/uploads/mNwd2PB5TxtLkWBXewwLwg/personas_4.jpg', 'https://cdn.magicpatterns.com/uploads/6TFdiYDgjPVtQyRhaTZgAQ/personas_3.jpg', 'https://cdn.magicpatterns.com/uploads/7D6rrqQkL3xzztBWLTZdsb/personas_2.jpg', 'https://cdn.magicpatterns.com/uploads/a9bFEvSE83bHbzDYttKmjN/personas_1.jpg'];
export function SuccessStories() {
  return <section className="py-24 bg-[#0a0514] overflow-hidden border-t border-[#27272a] pt-[9px] pb-[9px]" data-id="element-282">
      <div className="max-w-7xl mx-auto px-4 mb-16 text-center" data-id="element-283">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#00f0ff]/10 border border-[#00f0ff]/20 text-[#00f0ff] text-sm font-bold mb-6 tracking-wide" data-id="element-284">
          ✨ CASOS DE ÉXITO REALES
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-4xl md:text-6xl font-extrabold text-white mb-6 tracking-tight" data-id="element-285">
          RESULTADOS QUE <br data-id="element-286" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00f0ff] to-[#8b5cf6]" data-id="element-287">
            HABLAN POR SÍ SOLOS
          </span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-288">
          Mirá lo que nuestros alumnos están logrando. Personas reales,
          proyectos reales, resultados extraordinarios.
        </motion.p>
      </div>

      {/* Vertical Stack Container */}
      <div className="max-w-3xl mx-auto px-4 flex flex-col gap-12" data-id="element-289">
        {IMAGES.map((src, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative w-full aspect-square rounded-3xl overflow-hidden border border-[#27272a] group shadow-2xl" data-id="element-290">
            <img src={src} alt={`Alumno con su proyecto ${index + 1}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" data-id="element-291" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-60 group-hover:opacity-100 transition-opacity duration-300" data-id="element-292" />
          </motion.div>)}
      </div>

      <div className="mt-24 text-center" data-id="element-293">
        <p className="text-gray-500 font-medium italic text-lg" data-id="element-294">
          "El próximo proyecto puede ser el tuyo..."
        </p>
      </div>
    </section>;
}